import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ToastNotificationService } from '../../services/toast-notification/toast-notification.service';
import { Subscription } from 'rxjs';
import { ToastNotification } from '../../models/toast-notification';
import { ToastNotificationType } from '../../models/enums';
import { slideDown } from '../../../styles/animations/animations';

@Component({
  standalone: false,
  selector: 'res-toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.scss'],
  animations: [slideDown],
})
export class ToastNotificationComponent implements OnInit, OnDestroy {
  automationId: string = 'toast-notification';

  toasts: ToastNotification[] = [];
  private subscription: Subscription;

  constructor(private toastNotificationService: ToastNotificationService, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.subscription = this.toastNotificationService.toasts.subscribe(toasts => {
      this.toasts = toasts;
      this.changeDetectorRef.detectChanges();
    })
  }

  onMouseEnter(toast: ToastNotification) {
    this.toastNotificationService.pauseTimer(toast.id);
  }

  onMouseLeave(toast: ToastNotification) {
    this.toastNotificationService.resetTimer(toast.id, toast.duration);
  }

  removeToast(id: string) {
    this.toastNotificationService.removeToast(id);
  }

  getToastIcon(type: string): string {
    switch (type) {
      case ToastNotificationType.success:
        return 'fa-check';
      case ToastNotificationType.error:
        return 'fa-exclamation-circle';
      case ToastNotificationType.warning:
        return 'fa-exclamation-triangle';
      case ToastNotificationType.information:
      default:
        return 'fa-info-circle';
    }
  }

  // TrackBy function for better performance
  trackByToastId(index: number, toast: ToastNotification): string {
    return toast.id;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}